export default function calculatePrice(product, discount) {
  const { sale_price, price, quantity } = product;
  const basePrice = sale_price || price;

  if (discount) {
    if (discount.type === "percent") {
      return parseFloat(
        basePrice * (1 - discount.discount / 100) * quantity
      ).toFixed(2);
    } else {
      return parseFloat(basePrice - discount.discount * quantity).toFixed(2);
    }
  } else {
    return parseFloat(basePrice * quantity).toFixed(2);
  }
}



// WEBPACK FOOTER //
// ./src/helpers/calculatePrice.js